import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector } from '../../hooks/useSelector'
import { Segment, Header, Button } from 'semantic-ui-react'
import { Message, pullError } from '../../reducers/game/game'
import { useDispatch } from 'react-redux'
import classNames from 'classnames'
import { Box, Card, Typography } from '@prometheus/components'

type AutoDismissProps = {
  onClear: () => void
  duration?: number
}
const AutoDismiss = ({ onClear, duration = 8000 }: AutoDismissProps) => {
  const onClearRef = useRef(onClear)
  onClearRef.current = onClear
  const [width, setWidth] = useState('100%')
  useEffect(() => {
    // Use requestAnimationFrame to ensure the initial render completes before starting animation
    const animationFrame = requestAnimationFrame(() => {
      setWidth('0')
    })
    const timeout = setTimeout(() => onClearRef.current(), duration)

    return () => {
      cancelAnimationFrame(animationFrame)
      clearTimeout(timeout)
    }
  }, [duration])
  return (
    <div
      style={{
        width,
        transition: `width ${duration/1000}s linear`,
        backgroundColor: 'var(--prometheus-danger)',
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: '6px'
      }}
    />
  )
}

export default () => {
  const errors = useSelector(s => s.game.errors)
  const dispatch = useDispatch()
  const is_map = useSelector(s => s.game.galaxy_display)

  const onClear = useCallback((error: Message) => {
    dispatch(pullError(error))
  }, [dispatch])

  if (!errors.length) {
    return null
  }

  return (
    <div style={{ marginTop: '14px' }}>
      {[...errors].reverse().map((error) => {
        return (
          <Box key={`${error.message}-${error.type}-${error.id}`} bottom="sm" style={{ zIndex: 1, position: 'relative' }}>
            <Card interactive onClick={() => onClear(error)} style={{ position: 'relative', display: 'flex', alignItems: 'flex-start', flexDirection: 'row', gap: '6px' }} borderColor='danger' padding="sm">
              <Typography variant="h4" retro color="danger">
                Error: 
              </Typography>
              <Box top="sm">
                <Typography component="span" variant="h5" color="warning">{error.message}</Typography>
              </Box>
              <AutoDismiss onClear={() => onClear(error)} />
            </Card>
          </Box>
        )
      })}
    </div>
  )
}
